import { render, staticRenderFns } from "./BeneficiaryAccountGrant.vue?vue&type=template&id=df54090a"
import script from "./BeneficiaryAccountGrant.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountGrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports